<template>
  <div id="main-box" style="overflow:auto;">
    <div id="content-box">
      <el-tabs v-model="activeName" @tab-click="switchTabs">
        <el-tab-pane label="销售商品" name="first">
          <el-card>
            <div>
              <el-form :inline="true">
                <el-form-item label="商品spuid:">
                  <el-input size="small" v-model="tableForm.spuId" placeholder="请输入内容"></el-input>
                </el-form-item>
                <el-form-item label="商品名称:">
                  <el-input size="small" v-model="tableForm.proName" placeholder="请输入内容"></el-input>
                </el-form-item>
                <el-form-item label="商品品牌:">
                  <el-input size="small" v-model="tableForm.brand" placeholder="请输入内容"></el-input>
                </el-form-item>
                <el-form-item label="结算方式">
                  <el-select size="small" v-model="tableForm.payMethod">
                    <el-option :value="null" label="全部"></el-option>
                    <el-option :value="1" label="先货后款"></el-option>
                    <el-option :value="2" label="先款后货"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="商品状态">
                  <el-select size="small" v-model="tableForm.proStatus">
                    <el-option :value="null" label="全部"></el-option>
                    <el-option :value="true" label="上架"></el-option>
                    <el-option :value="false" label="下架"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="商品Skuid:">
                  <el-input size="small" v-model="tableForm.skuId" placeholder="请输入内容"></el-input>
                </el-form-item>
                <el-form-item label="分销商">
                  <el-select size="small" v-model="tableForm.distributor">
                    <el-option :value="null" label="全部"></el-option>
                    <el-option :value="1" label="审核中"></el-option>
                    <el-option :value="2" label="审核成功"></el-option>
                    <el-option :value="3" label="审核失败"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="同步状态">
                  <el-select size="small" v-model="tableForm.syncStatus">
                    <el-option :value="null" label="全部"></el-option>
                    <el-option :value="true" label="已同步"></el-option>
                    <el-option :value="false" label="未同步"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" size="small" @click="search_table">筛选</el-button>
                  <el-button size="small" @click="reset_table">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
            <div style="padding-bottom: 15px;">
              <toolbar
                  :buttonList="buttonList_toolBar"
                  @callFunction="callFunction"
              ></toolbar>
            </div>
            <el-table
              id="table-box"
              :data="tableList"
              highlight-current-row
              v-loading="tableLoading"
              @selection-change="tableSelectChange"
              style="width: 100%"
              border
            >
              <el-table-column
                type="selection"
                min-width="60"
                align="center">
              </el-table-column>
              <el-table-column
                prop="sort"
                label="排序"
                min-width="100"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="spuId"
                label="Spuid"
                min-width="100"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="skuId"
                label="Skuid"
                min-width="180"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="proPic"
                label="商品图片"
                min-width="180"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="proName"
                label="商品名称"
                min-width="180"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="proBrand"
                label="商品品牌"
                min-width="180"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="proType"
                label="商品类型"
                min-width="180"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="proSpec"
                label="商品规格"
                min-width="180"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="distributor"
                label="分销商"
                min-width="180"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="costPrice"
                label="成本价"
                min-width="180"
                align="center"
              ></el-table-column>
              <el-table-column
                label="供货价"
                min-width="180"
                align="center"
              >
                <template slot-scope="scope">
                  <el-input v-model="scope.row.supplyPrice" placeholder="请输入内容"></el-input>
                </template>
              </el-table-column>
              <el-table-column
                label="商品状态"
                min-width="180"
                align="center"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.proStatus == 1">上架</span>
                  <span v-if="scope.row.proStatus == 2">下架</span>
                </template>
              </el-table-column>
              <el-table-column
                label="同步状态"
                min-width="180"
                align="center"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.syncStatus == 1" style="color: green;">已同步</span>
                  <span v-if="scope.row.syncStatus == 2" style="color: red;">未同步</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="optionTime"
                label="操作时间"
                min-width="180"
                align="center"
              ></el-table-column>
              <el-table-column label="操作" align="center" min-width="250" fixed="right">
                <template slot-scope="scope">
                  <toolbar
                    :buttonList="buttonList_table"
                    :funcParams="scope.row"
                    @callFunction="callFunction"
                  ></toolbar>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              layout="total, sizes, prev, pager, next, jumper"
              style="float: right"
              :total="total"
              :current-page="tableForm.pageIndex"
              :pageSize="tableForm.pageSize"
              @current-change="pageCurrentChange_table"
              @size-change="pageSizeChange_table"
            ></el-pagination>
          </el-card>
        </el-tab-pane>
        <el-tab-pane label="操作日志" name="second">
          经销商返利
        </el-tab-pane>
      </el-tabs>
    </div>

    <el-dialog
      title="添加商品"
      :visible.sync="addProductDialog"
      v-if="addProductDialog"
      v-model="addProductDialog"
      :close-on-click-modal="false"
      width="80%"
    >
      <el-form :inline="true" ref="addProductForm" :model="addProductForm">
        <el-form-item label="选择分销商">
          <el-select size="small" v-model="addProductForm.distributor">
            <el-option :value="null" label="全部"></el-option>
            <el-option :value="1" label="快手阿修1"></el-option>
            <el-option :value="2" label="快手阿修1"></el-option>
          </el-select>
        </el-form-item>
        <div style="background-color: #F3F3F3;padding: 20px 20px 0 20px;border-radius: 6px;margin-bottom: 20px;">
          <el-form-item label="商品spuid:">
            <el-input
              v-model="addProductForm.spuId"
              placeholder="请输入商品Id"
            ></el-input>
          </el-form-item>
          <el-form-item label="商品名称:">
            <el-input
              v-model="addProductForm.proName"
              placeholder="请输入商品名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="商品型号:">
            <el-input
              v-model="addProductForm.proCode"
              placeholder="请输入型号"
            ></el-input>
          </el-form-item>
          <el-form-item label="商品类型">
            <el-select size="small" v-model="addProductForm.proType">
              <el-option :value="null" label="全部"></el-option>
              <el-option :value="1" label="类型1"></el-option>
              <el-option :value="2" label="类型2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品品牌">
            <el-select size="small" v-model="addProductForm.proType">
              <el-option :value="null" label="全部"></el-option>
              <el-option :value="1" label="品牌1"></el-option>
              <el-option :value="2" label="品牌2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin-left: 40px">
            <el-button type="primary" @click="search_addProduct">筛选</el-button>
            <el-button type="danger" @click="reset_addProduct">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
      <el-table
        :data="addProductList"
        @selection-change="productSelectChange"
        border
      >
        <el-table-column
          type="selection"
          width="50"
          fixed
          align="center"
        ></el-table-column>
        <el-table-column
          prop="spuId"
          label="SpuId"
          min-width="80"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="proName"
          label="商品名称"
          align="center"
          min-width="350"
        ></el-table-column>
        <el-table-column
          prop="proType"
          label="商品类型"
          min-width="110"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="proBrand"
          label="商品品牌"
          min-width="110"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="proCode"
          label="商品型号"
          min-width="110"
          align="center"
        ></el-table-column>
        <el-table-column 
          prop="costPrice" 
          label="成本价" 
          min-width="110" 
          align="center">
        </el-table-column>
      </el-table>
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        style="float: right"
        :total="total"
        :current-page="addProductForm.pageIndex"
        :pageSize="addProductForm.pageSize"
        @current-change="pageCurrentChange_addProduct"
        @size-change="pageSizeChange_addProduct"
      ></el-pagination>
      <div slot="footer" class="dialog-footer" style="width:100%;">
        <el-button @click.native="addProductDialog = false">取消</el-button>
        <el-button type="primary" @click.native="submitAddPro" :loading="submitLoading">下一步</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="设置价格"
      :visible.sync="setPriceDialog"
      v-if="setPriceDialog"
      v-model="setPriceDialog"
      :close-on-click-modal="false"
      width="75%"
    >
      <el-table
        border
        :data="setPriceList"
        :header-cell-style="{background:'#F3F3F3'}"
        id="act-set-table"
        :span-method="mergeColumn"
      >
        <el-table-column
          prop="proName"
          min-width="120"
          align="center"
          label="商品名称">
        </el-table-column>
        <el-table-column
          prop="distributor"
          min-width="120"
          align="center"
          label="分销商">
        </el-table-column>
        <el-table-column
          prop="specName"
          min-width="120"
          align="center"
          label="规格名称">
        </el-table-column>
        <el-table-column
          prop="costPrice"
          min-width="120"
          align="center"
          label="成本价">
        </el-table-column>
        <el-table-column label="供货价" min-width="120" align="center" style="border: red solid 1px;">
          <template slot-scope="scope">
            <el-input v-model="scope.row.supplyPrice" placeholder="请输入"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          min-width="100"
          align="center"
          label="操作">
          <template slot-scope="scope">
            <el-radio-group v-model="scope.row.proStatus">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addProductDialog = false, setPriceDialog = false">取消</el-button>
        <el-button type="primary" @click.native="submitSetPrice">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="商品同步"
      :visible.sync="proSyncDialog"
      v-if="proSyncDialog"
      v-model="proSyncDialog"
      :close-on-click-modal="false"
      width="75%"
    >
      <el-table
        border
        :data="syncList"
        :header-cell-style="{background:'#F3F3F3'}"
        id="act-set-table"
      >
        <el-table-column
          prop="distributor"
          min-width="120"
          align="center"
          label="分销商名称">
        </el-table-column>
        <el-table-column
          prop="synProNum"
          min-width="120"
          align="center"
          label="需同步商品数">
        </el-table-column>
        <el-table-column
          min-width="100"
          align="center"
          label="操作">
          <template slot-scope="scope">
            <el-button @click="oneKeySync(scope.row)" type="primary" size="small">一键同步</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="proSyncDialog = false">取消</el-button>
        <el-button type="primary" @click.native="submitOneKeySync">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="批量设置价格"
      :visible.sync="batchSetPriceDialog"
      v-if="batchSetPriceDialog"
      v-model="batchSetPriceDialog"
      :close-on-click-modal="false"
      width="75%"
    >
      <el-table
        border
        :data="batchSetPriceList"
        :header-cell-style="{background:'#F3F3F3'}"
        id="act-set-table"
      >
        <el-table-column
          prop="proName"
          min-width="120"
          align="center"
          label="商品名称">
        </el-table-column>
        <el-table-column
          prop="distributor"
          min-width="120"
          align="center"
          label="分销商">
        </el-table-column>
        <el-table-column
          prop="specName"
          min-width="120"
          align="center"
          label="规格名称">
        </el-table-column>
        <el-table-column
          prop="costPrice"
          min-width="120"
          align="center"
          label="成本价">
        </el-table-column>
        <el-table-column label="供货价" min-width="120" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.supplyPrice" placeholder="请输入"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          min-width="100"
          align="center"
          label="操作">
          <template slot-scope="scope">
            <el-radio-group v-model="scope.row.proStatus">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchSetPriceDialog = false">取消</el-button>
        <el-button type="primary" @click.native="submitBatchSetPrice">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {} from "../../api/api";
import toolbar from "../../components/Toolbar";
import {getButtonList} from "../../promissionRouter";
export default {
  components: {toolbar},
  data() {
    return {
      activeName: 'first',
      buttonList_toolBar: [],
      buttonList_table: [],
      tableLoading: false,
      submitLoading: false,
      currentRow: [],

      total: 0,
      tableForm: {
        spuId: null,
        proName: null,
        brand: null,
        payMethod: null,
        proStatus: null,
        skuId: null,
        distributor: null,
        syncStatus: null,
        pageIndex: 1,
        pageSize: 10
      },
      tableList: [
        {
          sort: 1,
          spuId: 11,
          skuId: 22,
          proPic: 'picUrl',
          proName: '商品1',
          proBrand: '美的',
          proType: '自有',
          proSpec: '规格',
          distributor: '美的',
          costPrice: 1111,
          supplyPrice: 3333,
          proStatus: 1,
          syncStatus: '2',
          optionTime: '2022-02-21 10:51'
        },
        {
          sort: 1,
          spuId: 11,
          skuId: 22,
          proPic: 'picUrl',
          proName: '商品1',
          proBrand: '美的',
          proType: '自有',
          proSpec: '规格',
          distributor: '美的',
          costPrice: 1111,
          supplyPrice: 3333,
          proStatus: 1,
          syncStatus: '2',
          optionTime: '2022-02-21 10:51'
        },
      ],

      addProductDialog: false,
      addProductForm: {
        SpuId: null,
        ProName: null,
        ProCode: null,
        ProTypeId: null,
        ProBrandId: null,
        pageIndex: 1,
        pageSize: 10
      },
      addProductList: [
        {
          SpuId: 11,
          ProName: 'pro1',
          ProTypeName: '自有',
          ProBrandName: '美的',
          ProCode: 222,
          CostPrice: 11111
        },
        {
          SpuId: 22,
          ProName: 'pro2',
          ProTypeName: '自有',
          ProBrandName: '海尔',
          ProCode: 22222,
          CostPrice: 3333
        },
        {
          SpuId: 22,
          ProName: 'pro2',
          ProTypeName: '自有',
          ProBrandName: '海尔',
          ProCode: 22222,
          CostPrice: 3333
        },
        {
          SpuId: 22,
          ProName: 'pro2',
          ProTypeName: '自有',
          ProBrandName: '海尔',
          ProCode: 22222,
          CostPrice: 3333
        },
        {
          SpuId: 22,
          ProName: 'pro2',
          ProTypeName: '自有',
          ProBrandName: '海尔',
          ProCode: 22222,
          CostPrice: 3333
        }
      ],

      setPriceDialog: false,
      setPriceList: [
        {
          proName: 'cc',
          distributor: 'cc',
          specName: 'dd',
          costPrice: 'dd',
          supplyPrice: 'dd',
          status: null
        },
        {
          proName: 'cc',
          distributor: 'cc',
          specName: 'dd',
          costPrice: 'dd',
          supplyPrice: 'dd',
          status: null
        },
      ],

      proSyncDialog: false,
      syncList: [
        {
          distributor: 'cc',
          proNum: 'cc'
        },
        {
          distributor: 'cc',
          proNum: 'cc'
        },
      ],

      batchSetPriceDialog: false,
      batchSetPriceList: [
        {
          proName: 'cc',
          distributor: 'cc',
          specName: 'dd',
          costPrice: 'dd',
          supplyPrice: 'dd',
          status: null
        },
        {
          proName: 'cc',
          distributor: 'cc',
          specName: 'dd',
          costPrice: 'dd',
          supplyPrice: 'dd',
          status: null
        },
      ],
    };
  },
  mounted() {
    this.renderButton();
  },
  methods: {
    switchTabs() {
      if (this.activeName == "first") {
        this.$router.push(`/Sale/Product`);
      }
      if (this.activeName == "second") {
        this.$router.push(`/Sale/OptionInto`);
      } 
    },
    mergeColumn({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    addProduct() {
      this.addProductDialog = true;
    },
    renderButton() {
      let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
      var buttonList = getButtonList(this.$route.path, routers);
      this.buttonList_toolBar = buttonList.filter((item) => {
        return item.buttonShow == 10 && item.isVisible;
      });
      this.buttonList_table = this.$utils.sortDataArrayAsc(buttonList.filter((item) => {
        return item.buttonShow == 20 && item.isVisible;
      }), 'order');
    },
    callFunction(item) {
      this[item.buttonFunc](item);
    },
    tableSelectChange(val) {
      this.currentRow = val;
    },
    pageCurrentChange_table(val) {
      this.tableForm.pageIndex = val;
    },
    pageSizeChange_table(val) {
      this.tableForm.pageSize = val;
    },
    search() {
      this.tableForm.pageIndex = 1;
      this.tableForm.pageSize = 10;
    },
    empty() {
      this.tableForm.Keyword = null;
      this.tableForm.IsActive = null;
      this.tableForm.pageIndex = 1;
      this.tableForm.pageSize = 10;
    },
    addUser() {
      this.userFormVisible = true;
      this.isEdit = false;
      this.userForm = {
        userName: null,
        name: null,
        surname: null,
        password: null,
        emailAddress: null,
        isActive: true,
        roleNames: []
      }
    },
    submitAddPro() {
      this.setPriceDialog = true;
      // this.$confirm("确认提交吗？", "提示", {
      //   closeOnClickModal: false,
      // }).then(() => {
      //   this.submitLoading = true;
      //   let that = this;
      //   UpdateUser(that.userForm).then((res) => {
      //     that.submitLoading = false;
      //     if (res.data.success) {
      //       that.$message.success('提交成功');
      //       that.setPriceDialog = false;
      //     } else {
      //       that.$message.error(res.data.error.message)
      //     }
      //   });
      // }).catch(() => {});
    },
    submitSetPrice() {
      let flag = true;
      try {
        this.setPriceList.forEach(x => {
          if (!x.supplyPrice && x.supplyPrice == '') {
            flag = false;
            this.$message.error('请输入供货价！');
            throw Error();
          }
          if (!/^[0-9]+(.[0-9]{1,2})?$/.test(x.supplyPrice)) {
            flag = false;
            this.$message.error('供货价必须为数字（可保留两位小数）');
            throw Error();
          }
          if (!x.status) {
            flag = false;
            this.$message.error('请选择上下架！');
            throw Error();
          }
        });
      } catch (e) {
      }
      if (flag) {
        this.$confirm("本次操作是否同步相应的分销商？", "提示", {
          closeOnClickModal: false,
        }).then(() => {
          // 调用接口，并同步
          this.setPriceDialog = false;
          this.addProductDialog = false;
        }).catch(() => {
          // 调用接口，不同步
          this.setPriceDialog = false;
          this.addProductDialog = false;
        });
      }
    },
    productSync() {
      this.proSyncDialog = true;
    },
    submitOneKeySync() {

    },
    batchSetPrice() {
      if (this.currentRow.length == 0) {
        return this.$message.error('请选择一行数据！');
      }
      this.batchSetPriceDialog = true;
    },
    submitBatchSetPrice() {
      let flag = true;
      try {
        this.batchSetPriceList.forEach(x => {
          if (!x.supplyPrice && x.supplyPrice == '') {
            flag = false;
            this.$message.error('请输入供货价');
            throw Error();
          }
          if (!/^[0-9]+(.[0-9]{1,2})?$/.test(x.supplyPrice)) {
            flag = false;
            this.$message.error('供货价必须为数字（可保留两位小数）');
            throw Error();
          }
        });
      } catch (e) {
      }
      if (flag) {
        this.$confirm("本次操作是否同步相应的分销商？", "提示", {
          closeOnClickModal: false,
        }).then(() => {
          // 调用接口，并同步
          this.batchSetPriceDialog = false;
        }).catch(() => {
          // 调用接口，不同步
          this.batchSetPriceDialog = false;
        });
      }
    },
    batchOffShelf() {
      if (this.currentRow.length == 0) {
        return this.$message.error('请选择一行数据！');
      }
    },
    batchShelves() {
      if (this.currentRow.length == 0) {
        return this.$message.error('请选择一行数据！');
      }
    },
    batchImport() {
      if (this.currentRow.length == 0) {
        return this.$message.error('请选择一行数据！');
      }
    },
    offTheShelf(params) {
      let row = params.funcParams;
    },
    productSync_tab(params) {
      let row = params.funcParams;
      if (!row.supplyPrice || row.supplyPrice == '') {
        var elements = document.querySelectorAll('#table-box .el-table__body-wrapper')[0];
        let scrollWidth = elements.scrollWidth;
        elements.scrollLeft  = scrollWidth;
        return this.$message.error('请输入供货价格！');
      }
    },
    detail(params) {
      let row = params.funcParams;
    }
  }
};
</script>
<style scoped>
#main-box
{
  width: 100%;
  height:100%;
}
#content-box
{
  padding: 0 20px 20px 20px;
  width: 100%;
  height: 100%;
}
#main-box /deep/ .el-pagination {
  padding: 10px 5px;
}


.tool_box {
  padding-top: 20px;
  overflow: hidden;
}

.flex{
  display:flex
}
.flex-center{
  align-items: center;
}
.data-detail-wrap{
  padding:30px;
}
.data-detail-wrap .dataBox{
  margin-top:40px;
}
.elSelect{
  width:200px;
}
.el-dialog{
  padding-bottom:0;
}
.img_box {
  width: 120px;
  height: 120px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  position: relative;
  margin-right: 10px;
  display:inline-block;
}
.img_box img {
  height: 100%;
  width: 100%;
  border-radius: 6px;
}
.del_box {
  position: absolute;
  top: -15px;
  right: -10px;
  width: 20px;
  height: 20px;
  cursor:pointer;
}
.play_btn{
  position: absolute;
  top: 50%;
  left:50%;
  transform:translate3d(-50%,-50%,0);
  z-index: 2;
}
.play_btn i{
  font-size: 25px;
  color: #666;
  border: 1px solid #666;
  border-radius: 50%;
  cursor:pointer;
}
.del_box img {
  height: 100%;
  width: 100%;
}
.avatar-uploader{
  display: inline-block;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.video-uploader{
  display:inline-block;
}
.video-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.videoWrap{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  background: rgba(0,0,0,.6);
}
.videoWrapInner{
  background:white;
  width:600px;
  height:400px;
}
.picPreview{
  display:flex;
  margin-bottom:15px;
}
.picPreview div{
  width:120px;
  height:120px;
  overflow:hidden;
  margin-right:10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  position:relative;
}
.del {
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  height: 20px;
  cursor:pointer;
}

.del img {
  height: 100%;
  width: 100%;
}
</style>
